import React from "react";
import NcaaWaterMarkBg from "../../assets/images/icons/ncaa-bg-cover.svg";
import NcaaLogo from "../../assets/images/icons/ncaa-logo.svg";
import NcaaTradeMarkLogo from "../../assets/images/icons/invoice-logo-water-mark.svg";
import InvoiceCustomerDetailsContainer from "./invoice-customer-details-container";
import InvoiceTable from "./invoice-table";
import { appHelpers } from "../../_helpers";

const InvoiceTemplate = ({
  customerName,
  location,
  customerNumber,
  customerPhoneNumber,
  customerEmail,
  invoiceTableData,
  invoiceDate,
}) => {
  const totalAmount = invoiceTableData?.quantity
    ? invoiceTableData?.amount * invoiceTableData?.quantity
    : invoiceTableData?.amount;
  return (
    <div className="invoice-template">
      <img src={NcaaWaterMarkBg} className="water-mark-bg" />
      <img src={NcaaTradeMarkLogo} className="trademark-logo" />
      <div className="invoice-head">
        <img src={NcaaLogo} />
        <div className="invoice-id-wrapper">
          <p className="invoice-text text-[24px] uppercase font-BebasNeueRegular">
            Invoice
          </p>
          <p className="invoice-id">
            No: {invoiceTableData?.invoiceNumber || "--------"}
          </p>
        </div>
      </div>
      <div className="organization-name-wrapper text-center mb-[40px] relative z-10">
        <p className="organization-name">NIGERIAN CIVIL AVIATION AUTHORITY</p>
        <p className="organization-address">
          ONLINE PAYMENT
        </p>
      </div>
      <InvoiceCustomerDetailsContainer
        customerName={customerName}
        location={location}
        customerNumber={customerNumber}
        customerPhoneNumber={customerPhoneNumber}
        customerEmail={customerEmail}
        invoiceDate={invoiceDate}
        invoiceTableData={invoiceTableData}
      />
      <InvoiceTable invoiceTableData={invoiceTableData} />
      <div className="invoice-words flex justify-between">
        <div></div>
        <div className="mt-[25px] w-[45%]">
          <p className="heading text-[#929292] text-[8px] font-medium">
            Amount In Words:
          </p>
          <p className="amount-in-words text-[#373737] text-[8px] font-semibold uppercase">
            {/* ------- */}
            {totalAmount
              ? appHelpers.withDecimal(totalAmount, "Naira", "Kobo")
              : "-------"}
          </p>
          <p className="guidelines ">
            Any complaint on the invoice must be raised within 7 days of the
            date of the receipt and should be addressed to; The General Manager,
            Commercial Services, Nigerian Civil Aviation Authority, Ikeja.
          </p>
          <p className="guidelines ">
            Please note that failure to pay your bill within 45 days of date of
            issue will subject you to a monthly surcharge of 2% compound
            interest on the outstanding balance until final settlement
          </p>
          <p className="guidelines main text-[7px] text-[#373737] font-medium">
            Note: Ensure payments are made via the invoice number provided. TSA
            processing fees applies
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
